import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { useDividendsFilter, useCurrentDividendsFilter, } from "../../../data/reports/dividends/hooks/useDividendsFilter";
import { LocalizationContext } from "../../../core/localization/Localization";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { DividendsFilterEditor } from "./DividendsEditor";
import { DividendsFilterChips } from "./DividendsFilterChips";

export const DividendsFilterButton: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<DividendsFiltersEditor />),
    [showWithDrawer]
  );

  const [filter, removefilter] = useCurrentDividendsFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <DividendsFilterChips filter={filter} removefilter={removefilter} />
      </Grid>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const DividendsFiltersEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useDividendsFilter();
  return (
    <DividendsFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
